// tslint:disable:max-line-length

import React from 'react';

export const ArrowChevronDownSmall = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8 8.94998L3 4.84998V7.04998L7.1 10.35L8 11.15L8.9 10.35L13 7.14998V4.94998L8 8.94998Z" fill="black" />
    </svg>
  );
};
